/* global ChoiceOption */
import React from 'react';
import { styled } from '@mui/material/styles';
import {
  FormControlLabel,
  Typography,
  Card,
  CardContent,
  FormGroup,
  Checkbox,
} from '@mui/material';
import { setChecked } from './helpers';
import { ChangeEvent } from './column-filter.types';

const StyledCardContent = styled(CardContent)({
  padding: 0,
  maxHeight: 350,
  '&:last-child': {
    padding: 0,
  },
});

const StyledFormGroup = styled(FormGroup, {
  shouldForwardProp: (prop) => prop !== 'options',
})<{ options: number }>(({ theme, options }) => ({
  padding: theme.spacing(1.25),
  ...(options > 6 && {
    maxHeight: 208,
    overflow: 'auto',
    flexWrap: 'nowrap',
  }),
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: theme.spacing(0.5),
}));

interface Props {
  selected: ChoiceOption[];
  values: ChoiceOption[];
  onChange: (option: ChoiceOption) => (e: ChangeEvent) => void;
}

const ColumnFilterFiltersBox: React.FC<Props> = ({ selected, ...props }) => (
  <Card variant="outlined">
    <StyledCardContent>
      <StyledFormGroup options={props.values.length}>
        {props.values.map((option: ChoiceOption) => (
          <FormControlLabel
            sx={{ margin: 0, paddingBottom: 0.5 }}
            key={option.value}
            label={option.label}
            control={(
              <StyledCheckbox
                name={option.value}
                checked={setChecked(selected, option.value)}
                onChange={props.onChange(option)}
              />
            )}
          />
        ))}
        {props.values.length === 200 && (
          <Typography variant="button">Use search to refine results.</Typography>
        )}
      </StyledFormGroup>
    </StyledCardContent>
  </Card>
);

export default ColumnFilterFiltersBox;
